import React, { useState } from "react";
import { toast } from "sonner";
import { Landmark, Upload, BadgeCheck } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/download";

export const PaProfileCard = () => {
  const { user, refresh } = useAuth();
  const [bio, setBio] = useState(user.bio || "");
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) { return; }
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try { await api.post("/me/logo", fd); await refresh(); toast.success("Logo caricato"); } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  const save = async () => { try { await api.patch("/me", { bio, onboardingDone: true }); await refresh(); toast.success("Profilo dell'Ente aggiornato"); } catch (err) { toast.error(errMsg(err)); } };
  const rows = [["Ente", user.entityName], ["Codice IPA", user.ipaEnteCode], ["Codice fiscale", user.taxCode], ["PEC istituzionale", user.pec], ["Comune", [user.city, user.province, user.region].filter(Boolean).join(" · ")], ["Referente", user.referentName && `${user.referentName}${user.referentRole ? ` (${user.referentRole})` : ""}`]];
  return (
    <div className={`mt-8 card-premium p-6 ${user.onboardingPending ? "ring-2 ring-gold" : ""}`} data-testid="pa-profile-card">
      <h3 className="font-display text-xl font-bold flex items-center gap-2 mb-1"><Landmark className="w-5 h-5 text-gold"/>Profilo dell'Ente</h3>
      {user.onboardingPending && <p className="text-sm text-aic-navy bg-gold/15 rounded-xl px-4 py-2 mb-3" data-testid="pa-onboarding-banner">Il profilo è già compilato con i dati ufficiali di IndicePA: aggiungi solo il logo e, se vuoi, una descrizione.</p>}
      {user.ipaVerifiedAt && <p className="text-xs text-emerald-700 flex items-center gap-1 mb-3"><BadgeCheck className="w-4 h-4"/>Dati verificati su IndicePA</p>}
      <div className="grid md:grid-cols-[auto_1fr] gap-6 items-start">
        <div className="flex flex-col items-center gap-2">
          <div className="w-28 h-28 rounded-2xl border border-slate-200 bg-[#F5F7FB] overflow-hidden flex items-center justify-center">
            {user.logoUrl ? <img src={mediaUrl(user.logoUrl)} alt="Logo" className="w-full h-full object-contain" data-testid="pa-logo"/> : <Landmark className="w-10 h-10 text-slate-300"/>}
          </div>
          <label className="btn-pill-outline !py-1.5 text-xs cursor-pointer"><Upload className="w-3.5 h-3.5"/>{busy ? "Caricamento…" : "Foto o logo"}<input type="file" accept="image/jpeg,image/png,image/webp" onChange={upload} data-testid="pa-logo-input" className="hidden"/></label>
        </div>
        <div>
          <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5 text-sm mb-4">{rows.filter(([, v]) => v).map(([k, v]) => <div key={k}><dt className="text-xs text-slate-500">{k}</dt><dd className="font-semibold break-words">{v}</dd></div>)}</dl>
          <textarea rows={3} maxLength={2000} value={bio} onChange={(e) => setBio(e.target.value)} placeholder="Descrizione dell'Ente (facoltativa)" data-testid="pa-bio" className="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-gold"/>
          <button onClick={save} data-testid="pa-profile-save" className="btn-pill-gold text-sm mt-2">Salva profilo</button>
        </div>
      </div>
    </div>
  );
};
